export default __webpack_public_path__ + "static/media/10.79ba0d42.png";